require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/modules/es6.array.species.js
// module id = 453
// module chunks = 0